<template>
  <div class="modal__wrapper">
    <div class="modal__close">
      <div class="btn" @click="close">
        <Close class="img"/>
      </div>
    </div>
    <div class="modal__header">
      <div class="ttl">
        Lead Matches
      </div>
    </div>
    <div class="modal__body">
      <div class="row">
        <h4 class="label" style="margin-right: 24px">Match by</h4>
        <div class="data">
          <div class="check-item-row">
            <div 
              class="check-item-col" 
              v-for="(field, i) in fieldsMatchingBy"
              :key="i"
            >
              <div class="check-item-wrap">
                <label class="check-item-label">
                  <input
                    type="checkbox"
                    :value="field.value"
                    v-model="form.match_by_field"
                    :true-value="[]"
                    name="match_by_field"
                    class="chec-item"
                    @change="getLeadMatches(1)"
                  />
                  {{ field.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box box_selectedAcc">
        <div class="header">
        </div>
        <div class="content">
          <div class="block">
            <div class="hdr">
            </div>
            <Table 
              class="lead-offer-match"
              @select-manager="selectManager" 
              :key="leadMatchesKey" 
              :options="leadMatches" 
              @sort="sortBy"
              @change-page="getLeadMatches"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from './../elem/Table.vue'
import Close from '../img/Close.vue'

export default {
  components: {
    Table,
    Close
  },
  props: {
    options: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      leadMatchesData: [],
      leadMatchesKey: 0,
      leadMatches: {
        objName: 'leads',
        colsWidth: ['7.08%', '7.08%', '7.08%', '7.08%', '7.08%', '2%', '7.08%', '7.08%', '7.08%', '7.08%', '7.08%', '7.08%', '7.08%', '2%', '11%'],
        header: [
          { ttl: 'Customer number', info: null },
          { ttl: 'Requeest Fintech type', info: null },
          { ttl: 'Requeest License type', info: null },
          { ttl: 'Requeest Country', info: null },
          { ttl: 'Requeest Client budget', info: null },
          { ttl: '', info: null },
          { ttl: 'License ID', info: null },
          { ttl: 'Type of license', info: null },
          { ttl: 'Fintech type', info: null },
          { ttl: 'Country', info: null, sort: null },
          { ttl: 'Price', info: null, sort: 'price' },
          { ttl: 'Is verified', info: null, sort: null },
          { ttl: 'Description', info: null },
          { ttl: '', info: null },
          { ttl: 'Who close deal', info: null },
        ],
        body: [],
        paginationData: null,
        sort: {
          name: '',
          order: 'asc',
          loading: false
        }
      },
      managers: [],
      clientBudgets: [
        {
          name: '< 100 K',
          value: 100000
        },
        {
          name: '< 250 K',
          value: 250000
        },
        {
          name: '< 500 K',
          value: 500000
        },
        {
          name: '< 1 M',
          value: 1000000
        },
        {
          name: '< 2 M',
          value: 2000000
        },
        {
          name: '< 5 M',
          value: 5000000
        },
        {
          name: '< 10 M',
          value: 10000000
        },
        {
          name: '> 10 M',
          value: 9999999999
        },
      ],
      form: {
        match_by_field: ['request_fintech_type_id', 'request_license_type', 'request_country_id', 'request_client_budget'],
      },
      fieldsMatchingBy: [
        {
          name: 'Request Business Type',
          value: 'request_fintech_type_id'
        },
        {
          name: 'Request License Type',
          value: 'request_license_type'
        },
        {
          name: 'Request Country',
          value: 'request_country_id'
        },
        {
          name: 'Request Client Budget',
          value: 'request_client_budget'
        },
      ],
    };
  },
  async created(){
    await this.getManagers()
    await this.getLeadMatches()
  },
  methods: {
    async getManagers () {
      const that = this
      await axios.get('admin/data/managers').then(function (response) {
        that.managers = response.data
      }).catch(function (error) {
        console.log(error);
      })
    },
    sortBy (data) {
      console.log(data);
      this.leadMatches.sort.loading = true
      this.leadMatches.sort.order = this.leadMatches.sort.name === data.sort && this.leadMatches.sort.order === 'asc'
        ? 'desc' : 'asc'
      this.leadMatches.sort.name = data.sort
      this.getLeadMatches(1)
    },
    async getLeadMatches (page = 1) {
      const that = this

      let url = 'admin/leads'

      if(this.options.id){
        url += '/get-matches/' + this.options.id
      }
      else{
        url += '/get-all-matches'
      }

      const sortParams = '&sort=' + this.leadMatches.sort.name + '&order=' + this.leadMatches.sort.order

      axios.post(url + '?page=' + page + sortParams, this.form).then(function (response) {
        that.leadMatches.paginationData = response.data
        that.leadMatches.body = []

        response.data.data.forEach(lead => {
          let leadData = [
            lead.customer_number,
            lead.request_fintech_type ? lead.request_fintech_type.name : '',
            lead.request_license_type,
            lead.request_country ? lead.request_country.name : '',
            that.getClientBudget(lead.request_client_budget),
            {type: 'seperator'},
          ];
          
          if(lead.matches.length){
            lead.matches.forEach(match => {
              that.leadMatches.body.push([
                ...leadData,
                match.id,
                match.license_type,
                match.fintech_type_id ? match.fintech_type.name : '',
                match.country_id ? match.country.name : '',
                match.price,
                match.is_verified ? 'Verified' : 'Not verified',
                match.description,
                {type: 'seperator'},
                {type: 'select-manager', managers: that.managers, lead_business_offer: that.getLeadBusinessOffer(lead.id, match)}
              ])
            })
          }
          else{
            that.leadMatches.body.push([
              ...leadData,
              '', '', '', '', '', '', '', '', 'Licenses Not Found'
            ]);
          }
          

          if (that.leadMatches.sort.name) that.leadMatches.sort.loading = false
        })
      }).catch((errors) => {
        console.dir(errors)
      })
    },
    selectManager(el){
      const that = this
      
      axios.post('admin/leads/' + el.el.lead_business_offer.lead_id + '/process-match', {
        business_offer_id: el.el.lead_business_offer.business_offer_id,
        manager_id: el.el.lead_business_offer.manager_id
      }).then(function(){

      }).catch((errors) => {
        console.dir(errors)
      })
    },
    getLeadBusinessOffer(leadId, businesOffer){
      for(let i = 0; i < businesOffer.leads.length; i++){
        const leadBusinessOffer = businesOffer.leads[i];
        
        if(leadBusinessOffer.pivot.lead_id == leadId){
          return leadBusinessOffer.pivot
        }
      }

      return {lead_id: leadId, business_offer_id: businesOffer.id, manager_id: null}
    },
    getClientBudget(value){
      for(let i = 0; i < this.clientBudgets.length; i++){
        const el = this.clientBudgets[i];
        
        if(+el.value == +value){
          return el.name
        }
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  &__wrapper {
    // height: 25rem;
  }

  &__header {
    padding: 2.5rem 0.75rem 1.5rem;
  }

  &__body {
    max-height: 80vh;
    display: block;
    padding-bottom: 2rem;
    overflow: auto;
  }
}

.box {
  &_selectedAcc {
    width: 100%;
  }
}

.tbl {
  color: #ffffff;
}

.block_mt {
  margin-top: 20px;
}
.inner-modal__wrapper{
  position: fixed;
  top: -100%;
  left: -100%;
  right: -100%;
  bottom: -100%;
  background: rgba(0, 0, 0, 0.5);
  .modal__body{
    display: block;
  }

  .inner-modal{
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #272E35;
    max-width: 100%;
    width: 520px;
    .ttl, .label{
      color: #fff
    }
    .row {
      width: 100%;
      display: flex;
      align-items: center;
      padding: .25rem 0;
      margin: .25rem 0 0;
      flex-wrap: wrap;

      .label {
        width: 100%;
        padding-right: .75rem;
        font-weight: bold;
      }

      .data {
        flex-grow: 1;
        width: 100%;

        .inpt {
          width: 100%;
          color: #fff;

          &__ta {
            height: 7rem;
          }
        }
      }

      &__price {
        .data {
          display: flex;

          input {
            margin-right: .75rem;
          }

          select {
            color: white;
            background-color: var(--c_more-black);
            padding: .25rem .5rem;
            border-radius: 6px;
          }
        }
      }
    }
    .row{
      &_files {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 8px;

        .box_addFiles {
          width: 30%;
          //width: calc(50% - .75rem);
          //margin: .75rem 0;
          //padding: 1rem 1.75rem;
          //background: #22252B;
          box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
          display: flex;
          flex-direction: column;

          .ttl {
            padding-bottom: .25rem;
          }

          .separ {
            width: 3rem;
            height: .25rem;
            background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
            box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
            border-radius: 14px;
            margin: .25rem 0;
          }

          .content {
            padding: 1rem;
            flex-grow: 1;
            //margin-top: 1rem;
            border: 1px dashed #1763fb;
            box-sizing: border-box;
            filter: drop-shadow(0px 12px 23px rgba(62, 73, 84, 0.04));
            border-radius: 14px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .choose {
              text-align: center;

              .btn {
                padding: 0.5rem;
                background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                border-radius: 6px;
                color: #fff;
                font-size: 13px;
              }

              .desc {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.3);
              }
            }

            &_many {
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: space-between;
              padding: 0.75rem 6px;

              .draggable {
                display: flex;
                padding: 0;
                flex-wrap: wrap;
              }

              .file {
                position: relative;
                text-align: center;
                width: 4.5rem;
                max-width: 4.5rem;

                svg.img {
                  width: 3rem;
                  height: 3rem;
                  margin: 0 auto;
                  cursor: pointer;
                  fill: #1763fb;
                  path{
                    fill: #1763fb;
                  }
                }
                .btn {
                  &_del {
                    position: absolute;
                    top: 0;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    background-color: #B03636;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 40%;
                      height: 40%;
                    }
                  }

                  &_download {
                    position: absolute;
                    top: 1.7rem;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 90%;
                      height: 90%;
                    }
                  }
                }

                .desc {
                  font-size: 10px;
                  color: #fff;
                  word-break: break-word;
                }
              }

              .add {
                text-align: center;
                width: 2.5rem;
                max-width: 2.5rem;

                .btn {
                  width: 2.5rem;
                  height: 2.5rem;
                  border-radius: 50%;
                  background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  svg.img {
                    width: 45%;
                    height: 45%;
                    transform: rotate(45deg);
                  }
                }

                .desc {
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
}
.check-item{
  &-row{
    display: flex;
    max-width: 100%;
    width: 100%;
    gap: 12px;
  }
  &-col{
    flex: 0 0 auto;
    max-width: 100%;
  }
  &-label{
    font-size: 16px;
    color: #000;
  }
}
.modal__wrapper{
  max-width: 95%;
}
</style>
